import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';

// Interface for the MarsCanvas component methods exposed to the registry
export interface MarsCanvasInstance {
  sceneState: any;
  setStarCount(count: number): void;
  setQualityTier(tier: string): void;
  toggleShootingStars(enabled: boolean): void;
  toggleBlurEffects(enabled: boolean): void;
  triggerShootingStar(): void;
  setRotationSpeed(multiplier: number): void;
  toggleMotion(enabled: boolean): void;
  setPerformanceTarget(fps: number): void;
}

export default class MarsCanvasRegistryService extends Service {
  @tracked marsCanvas: MarsCanvasInstance | null = null;

  register(canvas: MarsCanvasInstance) {
    this.marsCanvas = canvas;
  }

  unregister() {
    this.marsCanvas = null;
  }
}
